import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Ticket, CheckCircle2 } from "lucide-react";

const fmt = (d) => new Date(d + "T12:00").toLocaleDateString("en", { weekday: "long", month: "long", day: "numeric" });

export const WelcomePassCard = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/welcome-passes/mine").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data?.passes?.length) return null;
  return (
    <div className="rounded-3xl bg-gradient-to-br from-gold via-amber-300 to-coral p-[2px] mb-6" data-testid="welcome-pass-card">
      <div className="rounded-[22px] bg-white p-5 sm:p-6">
        <div className="flex items-center gap-2"><Ticket className="w-6 h-6 text-coral" /><p className="font-display font-black text-navy text-lg">FREE Welcome Day Pass</p></div>
        <p className="text-sm text-slate-600 mt-1">A one-time gift for Prospect Preschool families — come tour and play at our Berkeley facility. Valid <b>Saturdays & Sundays, 10 AM – 6 PM</b>, until <b>{fmt(data.rules.expires)}</b>. Show the code at the front desk.</p>
        <div className="grid sm:grid-cols-2 gap-3 mt-4">
          {data.passes.map((p) => (
            <div key={p.id} className={`rounded-2xl border-2 border-dashed p-4 ${p.status === "redeemed" || p.expired ? "border-slate-200 bg-slate-50" : "border-coral/50 bg-coral/5"}`} data-testid={`welcome-pass-${p.child_id}`}>
              <p className="text-xs font-bold text-slate-500 uppercase tracking-wider">{p.child_name}</p>
              {p.status === "redeemed" ? (
                <p className="font-bold text-emerald-600 mt-1 flex items-center gap-1"><CheckCircle2 className="w-4 h-4" />Used on {fmt(p.redeemed_date)}</p>
              ) : p.expired ? (
                <p className="font-bold text-slate-400 mt-1">Expired</p>
              ) : (
                <p className="font-mono font-black text-3xl text-navy tracking-widest mt-1" data-testid={`welcome-pass-code-${p.child_id}`}>{p.code}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
